import { render, staticRenderFns } from "./PressRelease-2024-07-11-barda.vue?vue&type=template&id=6d77edec&scoped=true"
import script from "./PressRelease-2024-07-11-barda.vue?vue&type=script&lang=js"
export * from "./PressRelease-2024-07-11-barda.vue?vue&type=script&lang=js"
import style0 from "./PressRelease-2024-07-11-barda.vue?vue&type=style&index=0&id=6d77edec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d77edec",
  null
  
)

export default component.exports